class ImageLinkComponent extends videojs.getComponent('Component') {
	constructor(player, options) {
		super(player, options);
		if (options.href) {
			this.el().querySelector('.vjs-image-link__link').href = options.href;
		}
		this.handleBackgroundImage();
		this.el().querySelector('.vjs-image-link__title').textContent = options.title;
	}

	createEl() {
		const el = videojs.dom.createEl('div', {className: 'vjs-image-link'});
		const link = videojs.dom.createEl('a', {className: 'vjs-image-link__link', target: '_blank'});
		const title = videojs.dom.createEl('span', {className: 'vjs-image-link__title'});
		el.append(link, title);
		return el;
	}

	handleBackgroundImage() {
		const breakpoints = Object.keys(this.options_.images)
			.filter(function checkNumber(key) {
				return parseInt(key, 10);
			})
			.sort(function descOrder(num1, num2) {
				return num2 - num1;
			});
		const applayBreakpoint = () => {
			const width = this.player_.currentWidth();
			this.el().style.backgroundImage = `url('${this.options_.images.base}')`;
			for (const point of breakpoints) {
				if (point >= width) {
					this.el().style.backgroundImage = `url('${this.options_.images[point]}')`;
					break;
				}
			}
		};
		this.player_.on('playerresize', applayBreakpoint);
		applayBreakpoint();
	}
}

videojs.registerComponent('imageLinkComponent', ImageLinkComponent);
